import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=74a5394c&scoped=true"
import script from "./tab.js?vue&type=script&lang=js&external"
export * from "./tab.js?vue&type=script&lang=js&external"
import style0 from "./tab.scss?vue&type=style&index=0&id=74a5394c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5394c",
  null
  
)

export default component.exports